<app-claims-list *ngIf="!ClaimsEditList"  [claimsOptions]="isEditClaimsView" (isListOptions)="EmitChildComponent($event)">
</app-claims-list>



<app-claims-edit *ngIf="ClaimsEditList" [isInputOptions]="isEditClaimsView" (isOutputOptions)="EmitChildComponent($event)">
</app-claims-edit>



